export default [
  {
    path: '/budget-requests-log',
    name: 'PageBudgetRequestsLogList',
    meta: { title: 'budgetRequestsLog.listTitle', roles: ['ADMIN'], permissions: ['budget_request_log_view'] },
    component: () => import('@/pages/budget-requests-log'),
  },
]